module.exports = __webpack_public_path__ + "static/media/Airbnb.af3db0f9.svg";